import React from 'react';
import InputGroup from 'react-bootstrap/InputGroup';
import Form from 'react-bootstrap/Form';

/*
Util functions for handling license data
 */

const makeOptions = licenseData => licenseData.map(license => (
	<option
		key = {license.license}
		value = {license.license}>{license.displayName}</option>
));

export const makeLicenseSelection = (licenseData, licenseHolder, onChange) => (
	<InputGroup
		hasValidation
		key = {'license'}>
		<InputGroup.Text>
			{'Lizenz'}
		</InputGroup.Text>
		<Form.Control
			as = {'select'}
			id = {'license-selection'}
			name = {'license'}
			value = {licenseHolder.license && licenseHolder.license.license}
			onChange = {onChange}>
			{makeOptions(licenseData)}
		</Form.Control>
	</InputGroup>
);
